import CryptoJS from 'crypto-js';
const salt = process.env.SALT || '9af1eaac-7c62-4fd0-9632-5a7581a0c3fe';

export const encryptData = data =>
  CryptoJS.AES.encrypt(JSON.stringify(data), salt).toString();

export const decryptData = ciphertext => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, salt);
  try {
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (err) {
    return null;
  }
};
